const doc = [({"da":({"js":({"admin":({"contacts":({"label":({"no_name":"Kontakt uden navn"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;